import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronLargeLeft"><Path d="M14.5 21.5L8.5 12L14.5 2.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronLargeLeft;
